/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_pw_symbols = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Symbols (!@#$%)`)
};

const es_pw_symbols = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Símbolos (!@#$%)`)
};

const de_pw_symbols = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Symbole (!@#$%)`)
};

const nl_pw_symbols = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Symbolen (!@#$%)`)
};

const fr_pw_symbols = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Symboles (!@#$%)`)
};

const it_pw_symbols = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simboli (!@#$%)`)
};

const pt_br2_pw_symbols = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Símbolos (!@#$%)`)
};

const pt_pw_symbols = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Símbolos (!@#$%)`)
};

const ja_pw_symbols = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記号 (!@#$%)`)
};

const zh_pw_symbols = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`符号 (!@#$%)`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const pw_symbols = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.pw_symbols(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("pw_symbols", locale)
	if (locale === "en") return en_pw_symbols(inputs)
	if (locale === "es") return es_pw_symbols(inputs)
	if (locale === "de") return de_pw_symbols(inputs)
	if (locale === "nl") return nl_pw_symbols(inputs)
	if (locale === "fr") return fr_pw_symbols(inputs)
	if (locale === "it") return it_pw_symbols(inputs)
	if (locale === "pt-BR") return pt_br2_pw_symbols(inputs)
	if (locale === "pt") return pt_pw_symbols(inputs)
	if (locale === "ja") return ja_pw_symbols(inputs)
	return zh_pw_symbols(inputs)
};